// extracted by mini-css-extract-plugin
module.exports = {"container":"flash-sale-status_container__1hAKk","textAction":"flash-sale-status_textAction__ZuKGC","adjustButton":"flash-sale-status_adjustButton___R0Go"};